import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../services/apiClient';
import { TaskType } from "../../config/config";
export const fetchAllTaskCode = createAsyncThunk(
  'taskCode/fetchAllTaskCode',
  async (_arg: any, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(TaskType, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'mode': 'outlook'

        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const taskCodeSlice = createSlice({
  name: 'taskCode',
  initialState: {
    taskCode: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllTaskCode.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllTaskCode.fulfilled, (state, action) => {
        state.loading = false;
        state.taskCode = action.payload;

        state.taskCode.sort((a, b) =>
                 a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
      })
      .addCase(fetchAllTaskCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default taskCodeSlice.reducer;
